<template>
	<div>
		<v-container v-if="missingRecord">
			<v-row justify="center">
				<v-col cols="12" sm="8" md="6" lg="4">
					<v-card>
						<v-card-title primary-title>
							<v-spacer></v-spacer>
							<div>حصل خطا</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<v-row dense>
								<v-col cols="12" class="text-center">الرجاء التواصل مع الإدارة</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-else>
			<v-breadcrumbs :items="breadcrumbs">
				<template #divider>
					<v-icon>mdi-chevron-left</v-icon>
				</template>
			</v-breadcrumbs>

			<v-stepper v-model="step" :alt-labels="$vuetify.breakpoint.mdAndDown">
				<v-stepper-header>
					<v-stepper-step
						:editable="consent && step > 0"
						edit-icon="mdi-check"
						:complete="step > 1"
						step="1"
					>
						المعلومات الأساسية
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 2"
						step="2"
					>
						المرفقات
					</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="0">
						<v-form v-model="valid0">
							<v-row dense>
								<v-col cols="12" class="text-center text-h5 pb-4">الإقرار</v-col>
								<v-col cols="12">
									<v-skeleton-loader v-if="!conditions" type="paragraph@2"></v-skeleton-loader>
									<pre v-else>{{ conditions }}</pre>
								</v-col>
								<v-col v-if="conditions" cols="12">
									<v-checkbox
										v-model="consent"
										hide-details="auto"
										label="أقر بأنني قرأت نص الإقرار المذكور أعلاه وأوافق على ذلك"
										:rules="[rules.required]"
									></v-checkbox>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :disabled="!valid0 || !conditions" @click="step = 1">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="1">
						<v-form v-model="valid1">
							<v-row no-gutters>
								<v-col cols="12" md="6">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="title"
												outlined
												hide-details="auto"
												label="العنوان"
												:rules="[rules.required, rules.maxLength75]"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-textarea
												v-model="description"
												outlined
												hide-details="auto"
												label="الوصف"
												:rules="[rules.maxLength250]"
											></v-textarea>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" md="6">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2 text-center">
											<v-btn-toggle v-model="isPhone">
												<v-btn :value="true">
													<v-icon :left="isPhone">mdi-cellphone</v-icon>
													<span v-if="isPhone">طريقة العرض الطولية</span>
												</v-btn>

												<v-btn :value="false">
													<span v-if="!isPhone">طريقة العرض العرضية</span>
													<v-icon :right="!isPhone">mdi-laptop</v-icon>
												</v-btn>
											</v-btn-toggle>
										</v-col>
										<v-col cols="12" class="pa-2 text-center">
											<v-avatar
												color="grey lighten-5"
												height="200"
												tile
												:width="200 * (isPhone ? 1/1.4 : 1.4)"
												class="mt-1"
											>
												<v-img
													contain
													style="border: 1px dotted grey"
													:src="cover | imgToURL"
													:aspect-ratio="isPhone ? 1/1.4 : 1.4"
												>
													<v-spacer></v-spacer>
													<v-chip v-if="isEdit" tile style="opacity: 0.5;">الصورة الجديدة</v-chip>
													<v-spacer></v-spacer>
												</v-img>
											</v-avatar>

											<v-avatar
												v-if="isEdit"
												color="grey lighten-5"
												height="200"
												tile
												:width="200 * (isPhone ? 1/1.4 : 1.4)"
												class="mt-1"
											>
												<v-img
													contain
													style="border: 1px dotted grey"
													:src="oldAttachment"
													:aspect-ratio="isPhone ? 1/1.4 : 1.4"
												>
													<v-spacer></v-spacer>
													<v-chip style="opacity: 0.5;" :href="oldAttachment" target="_blank">
														الصورة السابقة
														<v-icon right>mdi-file-eye</v-icon>
													</v-chip>
													<v-spacer></v-spacer>
												</v-img>
											</v-avatar>
										</v-col>
										<v-col cols="12" class="pa-2" style="padding-top: 23px !important;">
											<v-file-input
												v-model="cover"
												:rules="isEdit ? [rules.max2mb, rules.optionalImage] : [rules.required, rules.max2mb, rules.optionalImage]"
												accept="image/*"
												show-size
												prepend-inner-icon="mdi-camera"
												prepend-icon
												label="صورة عرض الخبر"
												outlined
												hide-details="auto"
											></v-file-input>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12">
									<v-row>
										<v-col cols="12" class="pa-2">
											<app-tiny-mce v-model="content" :rules="[rules.required]" class="px-3 py-0" title="محتوى الخبر"></app-tiny-mce>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="insertRecord">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="2">
						<v-form v-model="valid2">
							<v-row no-gutters>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newAttachment.name"
										outlined
										hide-details="auto"
										label="اسم الملف"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newAttachment.description"
										outlined
										hide-details="auto"
										label="الوصف (اختياري)"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-file-input
										v-model="newAttachment.attachment"
										outlined
										hide-details="auto"
										label="الملف"
										prepend-icon
										prepend-inner-icon="mdi-file-upload"
										:rules="[rules.max2mb]"
										show-size
									></v-file-input>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="success"
										:loading="loading"
										:disabled="!newAttachment.name || !newAttachment.attachment"
										@click="uploadAttachment"
									>
										إضافة
										<v-icon right>mdi-plus</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-data-table hide-default-footer :headers="attachmentHeaders" :items="attachments">
										<template #[`item.attachment`]="{ }">
											<v-tooltip bottom>
												<template #activator="{ on }">
													<v-btn icon medium v-on="on" @click=";">
														<v-icon medium>mdi-file-download</v-icon>
													</v-btn>
												</template>
												<span>تحميل</span>
											</v-tooltip>
										</template>

										<template #[`item.delete`]="{ item }">
											<v-tooltip bottom>
												<template #activator=" {on} ">
													<v-btn icon medium v-on="on" @click=";">
														<v-icon medium color="red" @click="removeAttachment(item.id)">mdi-file-remove</v-icon>
													</v-btn>
												</template>
												<span>حذف</span>
											</v-tooltip>
										</template>
									</v-data-table>
								</v-col>

								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" @click="goToNewsDashboard">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";
import { addBaseURL } from "@/utils/baseURL";
import appTinyMce from "@/components/AppTinyMCE";

export default {
	filters: {
		imgToURL(val) {
			if (val) return URL.createObjectURL(val);
			return "";
		}
	},
	components: {
		appTinyMce
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					to: { name: "dashboard-home" }
				},
				{
					text: "الأخبار",
					exact: true,
					to: { name: "dashboard-news" }
				},
				{
					text: "الإضافة",
					disabled: true
				}
			],
			consent: false,
			loading: false,
			step: 0,
			recordID: 2,
			valid0: false,
			valid1: false,
			valid2: false,
			conditions: null,
			title: "",
			description: "",
			cover: null,
			content: "",
			isPhone: true,
			attachments: [],
			attachmentHeaders: [
				{ text: "اسم الملف", value: "name" },
				{ text: "الوصف", value: "description" },
				{ text: "فتح الملف", value: "attachment" },
				{ text: "حذف الملف", value: "delete", sortable: false },
			],
			newAttachment: {
				name: null,
				attachment: null,
				description: null
			},
			isEdit: false,
			added: false,
			missingRecord: false,
			oldAttachment: false
		};
	},
	watch: {
		step () {
			this.$vuetify.goTo(0);
		}
	},
	mounted() {
		if (this.$route.params.recordID) {
			console.log("edit");
			this.isEdit = true;
			this.recordID = this.$route.params.recordID;
			this.consent = true;
			this.step = 1;
			this.breadcrumbs[2].text = "التعديل";
		} else {
			console.log("not edit");
		}

		if (!this.isEdit) {
			this.getConditions();
		}

		if (this.isEdit) {
			this.getPreviousInfo();
		}
	},
	methods: {
		getPreviousInfo() {
			client
				.get("/api/news/show/" + this.recordID)
				.then(response => {
					console.log(response);
					var newData = response.data.data;
					newData.coverPic = addBaseURL(newData.coverPic);

					newData.attachments = newData.attachments.map(att => {
						att.path = addBaseURL(att.path);
						if (att.description == "null") {
							att.description = null;
						}
						return att;
					});

					this.title = newData.title;
					this.description = newData.description;
					this.content = newData.body;

					if (newData.attachments) {
						this.attachments = newData.attachments;
					}

					newData.coverPic = addBaseURL(newData.coverPic);
					this.oldAttachment = newData.coverPic;

					setTimeout(() => {
						// on next tick, 0ms is enough
						this.valid1 = true;
					}, 100);
				})
				.catch(err => {
					this.missingRecord = true;
					console.log(err);
				});
		},
		getConditions() {
			client
				.get("/api/news/getcondition")
				.then(response => {
					this.loading = false;
					this.conditions = response.data;
					this.conditions = this.conditions || "...";
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		insertRecord() {
			this.loading = true;

			var data = new FormData();
			data.append("title", this.title);
			data.append("description", this.description);
			data.append("body", this.content);

			if (this.cover) {
				data.append("attachment", this.cover);
			}

			if (this.isEdit) {
				data.append("newsID", this.recordID);
				clientNotifier
					.post("/api/news/update", data)
					.then(() => {
						this.step = 2;
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				clientNotifier
					.post("/api/news/insert", data)
					.then(response => {
						this.recordID = response.data.data.id;
						this.isEdit = true;
						this.added = true;
						this.step = 2;
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		goToNewsDashboard() {
			this.$router.push({ name: "dashboard-news-manage" });
		},
		uploadAttachment() {
			this.loading = true;
			var data = new FormData();
			data.append("newsID", this.recordID);
			data.append("name", this.newAttachment.name);
			data.append("description", this.newAttachment.description);
			data.append("attachment", this.newAttachment.attachment);

			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			clientNotifier
				.post("/api/news/addAttachment", data, config)
				.then(response => {
					var insertedAttachment = { 
						id: response.data.data.id,
						name: response.data.data.name,
						description: response.data.data.description,
						attachment: addBaseURL(response.data.data.path),
					};
					this.attachments.push(insertedAttachment);
					this.newAttachment = {
						name: null,
						description: null,
						attachment: null
					};
				})
				.finally(() => {
					this.loading = false;
				});
		},
		removeAttachment(attachmentID){
			this.loading = true;

			client
				.delete("/api/attachment/delete/" + attachmentID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.attachments.findIndex(
						attachment => attachment.id == attachmentID
					);
					this.attachments.splice(index, 1);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
.ltr-content ::v-deep input {
	direction: ltr;
}
</style>